import axios from 'axios';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getBasicHeaders } from '../../common/utils/utils';
import { wrapAction } from '../../common/utils/actionLifecycle';

const champsEventState = () => {
    return {
        eventBaseURL: process.env.VUE_APP_BASE_URL,
        createEvent: null,
        chapterEvent: [],
        communityUsers: [],
        eventInfo: [],
        eventCustomFields: [],
        launchEvent: null,
    };
};
const champsEventMutations = {
    [storeMutation.setEventCustomFields]: (state, data) => {
        state.eventCustomFields = data;
    },
    [storeMutation.setEvent]: (state, data) => {
        state.chapterEvent = data;
    },
    [storeMutation.setSubmitEvent]: (state, data) => {
        state.createEvent = data;
    },
    [storeMutation.setCommunityUser]: (state, data) => {
        state.communityUsers = data;
    },
    [storeMutation.setEventInfo]: (state, data) => {
        state.eventInfo = data;
    },
    [storeMutation.setLaunchEvent]: (state, data) => {
        state.launchEvent = data;
    },
};
const champsEventActions = {
    [storeAction.getCommunityUsers]: wrapAction(storeAction.getCommunityUsers, async ({ state, commit }, communityId) => {
        return axios({
            url: `${state.eventBaseURL}events/api/champsevent/get-community-users/${communityId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setCommunityUser, response.data);
                return response;
            })
            .catch((err) => {
                commit(storeMutation.setCommunityUser, []);
                throw err;
            });
    }),
    [storeAction.submitEvent]: wrapAction(storeAction.submitEvent, ({ state, commit }, objectToSubmit) => {
        return axios({
            url: `${state.eventBaseURL}events/api/champsevent/create-event`,
            headers: getBasicHeaders(),
            data: objectToSubmit,
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.setSubmitEvent, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getEventById]: wrapAction(storeAction.getEventById, ({ state, commit }, params) => {
        return axios({
            url: `${state.eventBaseURL}events/api/champsevent/get-cvent/${params.cid}/${params.eid}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setEvent, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.deleteEventAttachment]: ({ state }, params) => {
        return axios({
            url: `${state.eventBaseURL}events/api/champsevent/delete-attachment`,
            headers: getBasicHeaders(),
            data: params,
            method: "DELETE",
        })
            .then((response) => {
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getEventInfo]: wrapAction(storeAction.getEventInfo, async ({ state, commit }, communityId) => {
        return axios({
            url: `${state.eventBaseURL}events/api/champsevent/get-event-lookup/${communityId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setEventInfo, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getEventCustomFields]: wrapAction(storeAction.getEventCustomFields, async ({ state, commit }, communityId) => {
        return axios({
            url: `${state.eventBaseURL}events/api/champsevent/get-event-custom-fields/${communityId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setEventCustomFields, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.launchEvent]: wrapAction(storeAction.launchEvent, ({ state, commit }, params) => {
        return axios({
            url: `${state.eventBaseURL}events/api/champsevent/launch-cvent/${params.cid}/${params.eid}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setLaunchEvent, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
};
const champsEventGetters = {
    [storeGetters.createEvent]: state => state.createEvent,
    [storeGetters.chapterEvent]: state => state.chapterEvent,
    [storeGetters.communityUsers]: state => state.communityUsers,
    [storeGetters.eventInfo]: state => state.eventInfo,
    [storeGetters.eventCustomFields]: state => state.eventCustomFields,
    [storeGetters.launchEvent]: state => state.launchEvent,
};
export default {
    namespaced: true,
    state: {
        initialState: champsEventState(),
        ...champsEventState(),
    },
    mutations: { ...champsEventMutations },
    actions: { ...champsEventActions },
    getters: { ...champsEventGetters },
};
